import script from "./WorkspacePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&setup=true&lang=js"

import "./WorkspacePage.vue?vue&type=style&index=0&id=1184931a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1184931a"]])

export default __exports__